function parseDateTime(dateStr, timeStr) {
  if (!dateStr) return null;
  const [y, m, d] = dateStr.slice(0, 10).split("-").map(Number);
  let hh = 0, mm = 0, hasTime = false;
  if (timeStr) {
    const match = String(timeStr).trim().match(/(\d{1,2})(?::(\d{2}))?\s*(am|pm)?/i);
    if (match) {
      hh = parseInt(match[1], 10);
      mm = match[2] ? parseInt(match[2], 10) : 0;
      const ap = match[3] ? match[3].toLowerCase() : "";
      if (ap === "pm" && hh < 12) hh += 12;
      if (ap === "am" && hh === 12) hh = 0;
      hasTime = true;
    }
  }
  return { y, m, d, hh, mm, hasTime };
}

const pad = (n) => String(n).padStart(2, "0");
const dstamp = (d) => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;
const dtstamp = (d) => `${dstamp(d)}T${pad(d.getHours())}${pad(d.getMinutes())}00`;
const esc = (t) => String(t || "").replace(/([,;\\])/g, "\\$1").replace(/\n/g, "\\n");

export function downloadIcs(e) {
  if (!e || !e.date) return;
  const s = parseDateTime(e.date, e.start_time);
  const allDay = !s.hasTime;
  const startD = new Date(s.y, s.m - 1, s.d, s.hasTime ? s.hh : 0, s.hasTime ? s.mm : 0);

  let endD;
  if (allDay) {
    const ed = e.end_date ? parseDateTime(e.end_date, null) : s;
    endD = new Date(ed.y, ed.m - 1, ed.d);
    endD.setDate(endD.getDate() + 1); // DTEND is exclusive for all-day
  } else if (e.end_time) {
    const en = parseDateTime(e.end_date || e.date, e.end_time);
    endD = new Date(en.y, en.m - 1, en.d, en.hh, en.mm);
  } else {
    endD = new Date(startD.getTime() + 2 * 3600 * 1000);
  }

  const loc = [e.venue, e.location, e.city].filter(Boolean).join(", ");
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Tastebuds Food Network//Events//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${e.id}@tastebudsfoodnetwork.com`,
    `DTSTAMP:${dtstamp(new Date())}`,
    allDay ? `DTSTART;VALUE=DATE:${dstamp(startD)}` : `DTSTART:${dtstamp(startD)}`,
    allDay ? `DTEND;VALUE=DATE:${dstamp(endD)}` : `DTEND:${dtstamp(endD)}`,
    `SUMMARY:${esc(e.name)}`,
    `DESCRIPTION:${esc(e.short_description || e.long_description || "")}`,
    `LOCATION:${esc(loc)}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ];
  const blob = new Blob([lines.join("\r\n")], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(e.name || "event").replace(/[^a-z0-9]+/gi, "_")}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
